<nav class="admin-menu">
  <ul>
    <li><a routerLink="/category">Kategóriák</a></li>
    <li><a routerLink="/cut-flower-stock">Vágott virág készlet</a></li>
  </ul>
</nav>
